import { createReportPdfDoc, drawFilterAndKpiBoxes, drawTable } from "./reportPdfBase";

export async function generateStandardReportPdf({ title, filters, kpis, columns, rows }) {
  const isWide = (columns || []).length > 6 || (columns || []).some((c) => String(c?.name || "").length > 18);
  const orientation = isWide ? "landscape" : "portrait";

  const { doc, pageWidth, marginX, y } = await createReportPdfDoc({ title, orientation });
  let cursorY = y;

  cursorY = drawFilterAndKpiBoxes({ doc, pageWidth, marginX, startY: cursorY, filters, kpis });
  drawTable({ doc, startY: cursorY, columns, rows });

  const dataUri = doc.output("datauristring");
  const base64 = dataUri.split(",")[1];
  return { dataUri, base64 };
}

